import clsx from 'clsx';
import React from 'react';
import { PageSkeleton } from '../Loading/PageSkeleton';

interface IPageWrapper {
  loading?: boolean;
  title?: string;
  children: React.ReactNode;
  rootClassName?: string;
}

export function PageWrapper({
  loading,
  title,
  children,
  rootClassName,
}: Readonly<IPageWrapper>) {
  if (loading) {
    return <PageSkeleton />;
  }

  return (
    <div
      className={clsx(
        'min-h-full rounded-md animate-fade-in-up',
        rootClassName
      )}
    >
      {title && (
        <div className='font-bold pb-6 max-md:pb-4 text-B-20 text-wl-on-background opacity-40'>
          {title}
        </div>
      )}
      {children}
    </div>
  );
}
